import qs from 'qs'
import instance from '@/helpers/axios'
import moment from 'moment'
import numeral from 'numeral'
import groupArray from 'group-array'

const state = {
    length_of_stay_beginDate: null,
    length_of_stay_lastDate: null,
    length_of_stay_datasets: [],
    length_of_stay_state: [],
    //v2
    length_of_stay_year: {},
    length_of_stay_isLoading: false,
    n_year_x_length_travel_type: {}
}

// getters
const getters = {
    length_of_stay_year: state => {
        return state.length_of_stay_year;
    },
    length_of_stay_isLoading: state => {
        return state.length_of_stay_isLoading;
    },
    length_of_stay_data_date: state => {
        if (state.length_of_stay_beginDate !== null) {
            var _start = state.length_of_stay_beginDate.split("T");
            var _end = state.length_of_stay_lastDate.split("T")
            return _start[0] + " to " + _end[0];
        }else{
            return "N/A"
        }         
    },
    length_of_stay_datasets: state => {
        return state.length_of_stay_datasets;
    },
    length_of_stay_state: state => {
        return state.length_of_stay_state;
    },
}

// actions
const actions = {
    // start /v2 actions
    V2getLength_of_stayDatasets(context, payload) {
        state.length_of_stay_isLoading = true;
        var _params = {};
        // calulate _params from main_filters                
        var main_filters = payload.main_filters;
        if (main_filters !== null) {
            if (main_filters.location_source !== null) {
                _params.location_source = main_filters.location_source;
            }
        }
        const request = {
            params: qs.parse(_params)
        };
        instance.get('v2/tourist/length_of_stay', request)
            .then(response => {
                const {
                    year,
                    n_year_x_length_travel_type,
                } = response.data;

                state.n_year_x_length_travel_type = n_year_x_length_travel_type;
                state.length_of_stay_year = year;
                state.length_of_stay_beginDate = moment(new Date(year.start + "-01-01")).format("YYYY-MM-DD");
                state.length_of_stay_lastDate = moment(new Date(year.end + "-12-31")).format("YYYY-MM-DD");

                payload.stateDatasets.forEach(function(stateName) {
                    if (stateName == "length_of_stay_state") {
                        context.commit("V2onLengthStay", payload);
                    }
                })
                state.length_of_stay_isLoading = false;
            })
            .catch(error => {
                console.log(error.response, "[store/v2/tourist/length_of_stay] syntax errors under instant.get");
            })
    },
    getLength_of_stayDatasets(context, payload) {
        console.log("[store/tourist/length_of_stay] getLength_of_stayDatasets() DEPRECATED");
        return;
    }
}

// mutations
const mutations = {
    // start /v2 mutations
    V2onLengthStay() {
        // --- start dataset for stack chart
        // items = [{label1:0,label2:0,...,year:string}] 
        var colors = [];
        colors['จัดการเดินทางผ่านบริษัทนำเที่ยว'] = '#3241a6';
        colors['จัดการเดินทางมาเอง'] = '#578e47';

        var rows = state.n_year_x_length_travel_type.rows;
        var items = [];
        var total = 0;
        rows.forEach(function(item, index) {
            total += item.avg_sum_length_travel_avg_day;
            var _item = {};
            var pos = items.map(function(e) {
                return e.year;
            }).indexOf(item._id.year);
            if (pos == -1) {
                _item['year'] = item._id.year;
                _item['จัดการเดินทางผ่านบริษัทนำเที่ยว'] = 0;
                _item['จัดการเดินทางมาเอง'] = 0;
                _item[item._id.length_travel_type] = item.avg_sum_length_travel_avg_day;
                items.push(_item);
            } else {
                _item = items[pos];
                if (_item[item._id.length_travel_type] === undefined) {
                    _item[item._id.length_travel_type] = item.avg_sum_length_travel_avg_day;
                } else {
                    _item[item._id.length_travel_type] += item.avg_sum_length_travel_avg_day;
                }
                items[pos] = _item;
            }
        });

        // sort by date year        
        items.sort(function(a, b) {
            var _a = parseInt(a.year);
            var _b = parseInt(b.year);
            return _a - _b;
        });

        // attached colors 
        items.push(colors);

        if (total == 0) {
            items = [];
        }

        state.length_of_stay_state = items;
        // --- end dataset for stack chart
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}